const defaultStyles = {
  borderBottomWidth: "0",
  borderColor: "var(--color-gallery-200)",
  borderLeftWidth: "0",
  borderRightWidth: "0",
  borderStyle: "solid",
  borderTopWidth: "0.2rem",
  color: "var(--color-gallery-500)",
  fontSize: "1.5rem",
  fontWeight: "500",
  marginTop: "0.75rem",
  paddingTop: "1.25rem",
};

const defaultProps = {
  label: "",
  hideBorder: false,
};

export default function FormBodySectionTitle(props) {
  const {
    label,
    hideBorder,
  } = { ...defaultProps, ...props };

  const styles = Object.assign({}, defaultStyles);

  if (label === undefined || label === null) {
    styles.paddingTop = "0";
  }

  if (hideBorder) {
    styles.borderTopWidth = "0";
    styles.marginTop = "0";
    styles.paddingTop = "0";
  }

  return (
    <div className="col-span-24">
      <div style={styles}>
        {label}
      </div>
    </div>
  );
}
